import axios from "axios";
import VueCookie from "vue-cookie"
import router from '@/router'
import AWS from '@/resources/AWS.js'
import hash from "object-hash"
import store from "@/store/store.js"

let API_with_auth = axios.create({
    withCredentials: true,
    baseURL: `https://pp3.skarb.club`,
    // baseURL: `http://127.0.0.1:8888/`,
    headers: {
        Authorization: {
            toString() {
                return `Bearer ${VueCookie.get("access_token")}`
            }
        }
    }
})

API_with_auth.interceptors.response.use(null, function(error) {
    const originalRequest = error.config;
    const response = error.response;
    console.log(response);

    if (response.status === 401) {
        // if (true) {
        var URItoReturn = ""
        //state_id in router is not up to date => take state_id from store
        // console.log(router.currentRoute);
        // console.log(store);
        // debugger;
        if (router.history.pending) URItoReturn = router.history.pending.fullPath
        else {
            if (router.currentRoute.name == "overvieww") URItoReturn = "/overview/" + store.state.stateId
            else URItoReturn = router.currentRoute.fullPath
        }

        // console.log(URItoReturn);
        // debugger;
        return AWS.validateTokens(URItoReturn).
        then(() => {
                // replace the expired token and retry
                originalRequest.headers['Authorization'] = `Bearer ${VueCookie.get("access_token")}`;
                return Promise.resolve(axios(originalRequest));
            })
            .catch(error => {
                console.log(error);
            })
    }
    return Promise.reject(error)
})

export default {
    GetTableData(params) {
        console.log("Calling /SLICE");
        console.log(JSON.stringify(params));
        let URL = '/view/slice/'

        return API_with_auth.post(URL, {
            ...params,
        })
    },
    GetChartData(params) {
        console.log("Calling /HISTORY");
        console.log(JSON.stringify(params));
        let URL = '/view/history/'

        return API_with_auth.post(URL, {
            ...params,
        })
    },
    GetMeta() {
        console.log("Calling /META");
        return API_with_auth.get('/view/meta/')
    },
    GetState(stateId) {
        console.log("Calling GET /STATES/");
        console.log(stateId);
        return API_with_auth.get('/states/' + stateId)
    },
    SaveUpcomingState(state, prevHash) {
        let newHash = hash(state)
        if (newHash === prevHash) return
        this.saveState(state)
            .then(response => {
                store.commit('updateState', {
                    hash: newHash,
                    stateId: response.data.state_id,
                })
                //TODO: this causing reload
                // router.push({
                //     name: 'overvieww',
                //     params: {
                //         state_id: response.data.state_id
                //     }
                // }).catch(() => {})
                history.pushState({},
                    null,
                    "/overview/" + response.data.state_id
                )
            })
            .catch(error => {
                console.log(error.response);
            })
    },
    AddToBlacklist(reqBody) {
        console.log("Calling POST /blacklist")
        let URL = '/view/blacklist'
        return API_with_auth.post(URL, reqBody)
    },
    saveState(params) {
        console.log("Calling POST /STATES/");
        let URL = '/states/'

        return API_with_auth.post(URL, {
            ...params,
        })
    },
}
